import React, { useRef, useEffect } from "react"
import * as styles from "./DocumentsList-tw-styles"
import PropTypes from "prop-types"

const style = styles.documentList || styles.defaultStyle

const DocumentsList = props => {
  return (
    <>
      <div className={style?.heading}>
        <div>Documents</div>
        <div className={style?.subHeading}>Public Date</div>
      </div>
      {props?.brandsListCollection?.items?.map((brands, index) => {
        return (
          <div className={style?.container} key={index}>
            <h2 className={style?.brandName}>{brands?.brandName}</h2>
            {brands?.mainDocumentsListCollection?.items?.map(
              (mainDoc, index) => {
                return (
                  <div key={index} className={style?.infoContainer}>
                    <div className={style?.infoDate}>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={mainDoc?.mainDocumentWithLabel?.url}
                        className="flex"
                      >
                        <p className="mr-[5px] font-bold">{`${index + 1}.`}</p>
                        {mainDoc?.mainDocumentWithLabel?.label}
                      </a>

                      <p>{mainDoc?.publishDate}</p>
                    </div>
                    {mainDoc?.subDoumentsListWithLabelCollection?.items?.map(
                      (subDoc, ind) => (
                        <div key={ind} className={style?.subdata}>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={subDoc?.url}
                          >
                            {subDoc?.label}
                          </a>
                        </div>
                      )
                    )}
                  </div>
                )
              }
            )}
          </div>
        )
      })}
    </>
  )
}

DocumentsList.propTypes = {
  brandsListCollection: PropTypes.object,
}

export default DocumentsList
